<template>
  <div
    class="bg-bgr-secondary flex h-[53px] cursor-text items-center gap-3 overflow-hidden rounded-[inherit] px-4 py-3.5"
    @click="focusInput"
  >
    <Icon src="MagnifyingGlass" :size="ComponentSize.lg" />
    <div class="global-search_old-input-wrapper relative w-full bg-inherit">
      <input
        v-bind="$attrs"
        ref="input"
        v-model="gsStore.search"
        autocomplete="one-time-code"
        class="text-body-large w-full bg-inherit leading-none font-medium focus-within:outline-none"
        type="text"
      />
      <div v-if="!gsStore.search" class="text-body-large absolute top-1 left-0 leading-none font-medium opacity-50">
        <span class="holder-search-placeholder w-full">
          {{ t("search by") }}
          <span class="search-placeholder-word">{{ t("package_number").toLocaleLowerCase() }}</span>
          <span class="search-placeholder-word">{{ t("reference").toLocaleLowerCase() }}</span>
          <span class="search-placeholder-word">{{ t("receiver").toLocaleLowerCase() }}</span>
        </span>
      </div>
    </div>
    <Button
      v-show="gsStore.search && gsStore.search.length"
      class="!rounded-full"
      icon-only
      @click="() => (gsStore.search = '')"
    >
      <Icon src="bold/X" />
    </Button>
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: "GlobalSearchInput",
    inheritAttrs: false,
  });

  const props = withDefaults(
    defineProps<{
      show?: boolean;
    }>(),
    {
      show: false,
    }
  );
  const gsStore = useGlobalSearchStore();

  const input = ref<HTMLInputElement | null>(null);
  const { t } = useI18n();

  const focusInput = () => {
    input.value?.focus();
  };

  defineExpose({
    focus() {
      input.value?.focus();
    },
  });
</script>
